// client/src/components/common/layout/HeaderButton.js
import React from 'react'
import './PageHeader.css'

function HeaderButton({
  onClick,
  title,
  icon,
  label,
  className = 'modern-btn modern-btn-secondary',
  dataTrack,
  style = {},
  badge = null,
  ariaLabel,
}) {
  return (
    <button
      className={`${className} header-btn rounded-pill d-flex align-items-center justify-content-center`}
      onClick={onClick}
      title={title}
      data-track={dataTrack}
      aria-label={ariaLabel || label || title}
      style={{ position: 'relative', ...style }}
    >
      <span>{icon}</span>
      {label && <span className="d-none d-sm-inline ms-1">{label}</span>}
      {badge}
    </button>
  )
}

export default HeaderButton
